var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.Badge,{staticClass:"role-badge",attrs:{"status":_setup.badgeStatus(_vm.role)}},[_vm._v("\n  "+_vm._s(_vm.role)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }